import type { Task } from '@coachapp/shared';
import { formatIsoDate } from './today.ts';

/** Open tasks due on the selected day. On today, overdue tasks are included too. */
export function selectTodayTasks(tasks: Task[], selectedDate: string, now: Date): Task[] {
  const today = formatIsoDate(now);
  return tasks
    .filter((task) => {
      if (task.status !== 'OPEN' || !task.dueAt) return false;
      const due = formatIsoDate(new Date(task.dueAt));
      if (due === selectedDate) return true;
      return selectedDate === today && due < today;
    })
    .sort((a, b) => new Date(a.dueAt!).getTime() - new Date(b.dueAt!).getTime());
}

export function isOverdueDue(dueAt: string, now: Date): boolean {
  return formatIsoDate(new Date(dueAt)) < formatIsoDate(now);
}
